<style lang='less' scoped>
@import '../base.less';
</style>
<template>
  <div>
    <!-- SEARCH -->
    <Row>
      <Col span="24">
        <Card class="margin-bottom-10">
          <Form inline>
            <FormItem class='margin-bottom-0'><Select v-model='searchConf.setting_pay_channel_id' clearable :placeholder="$t('提现卡类型') "
                                                      style='width:120px'>
              <Option :key="key" :value="value.id"
                      v-for="(value, key) in allPayTitle"> {{ value.pay_name }}
              </Option>
            </Select>
            </FormItem>
            <FormItem class='margin-bottom-0'>
              <Input clearable v-model='searchConf.username' :placeholder="$t('用户名') "></Input>
            </FormItem>
            <FormItem class='margin-bottom-0'>
              <Input clearable v-model='searchConf.p1' :placeholder="$t('参数1') "></Input>
            </FormItem>
            <FormItem class='margin-bottom-0'>
              <Input clearable v-model='searchConf.p2' :placeholder="$t('参数2') "></Input>
            </FormItem>
            <FormItem class='margin-bottom-0'>
              <Input clearable v-model='searchConf.p3' :placeholder="$t('参数3') "></Input>
            </FormItem>
            <FormItem class='margin-bottom-0'>
              <Input clearable v-model='searchConf.p4' :placeholder="$t('参数4') "></Input>
            </FormItem>
            <FormItem class='margin-bottom-0'>
              <Input clearable v-model='searchConf.p5' :placeholder="$t('参数5') "></Input>
            </FormItem>
            <FormItem class='margin-bottom-0'>
              <Input clearable v-model='searchConf.p6' :placeholder="$t('参数6') "></Input>
            </FormItem>
            <FormItem class="margin-bottom-0">
              <Button type="primary" @click="search">{{ $t('find_button') }}</Button>
            </FormItem>
          </Form>
        </Card>
      </Col>
    </Row>        <!--    -->
    <Row>
      <Col span='24'>
        <Card>
          <!-- ADDBUTTON -->
          <div class='margin-bottom-15'>
            <Button type='primary' v-has="'userManage/userWithdrawCar/add'" @click='preAdd' icon='md-add'>
              {{ $t('add_button') }}
            </Button>
          </div>
          <!-- DATA -->
          <div>
            <Table :loading='listLoading' :columns='columnsList' :data='tableData' border></Table>
          </div>
          <!-- PAGE -->
          <div class='margin-top-15' style='text-align: center'>
            <Page :total='tableShow.listCount' :current='tableShow.currentPage' :page-size='tableShow.pageSize'
                  @on-change='changePage' @on-page-size-change='changeSize'
                  :page-size-opts='[10,20,30,40,50,100,200,300]' show-elevator show-sizer show-total></Page>
          </div>
        </Card>
      </Col>
    </Row>
    <!-- windowAddEdit -->
    <Modal v-model="windowAdd.show" width="668" :styles="{top: '30px'}" @on-visible-change="windowAddCancel">
      <p slot="header" style="color:#2d8cf0">
        <Icon type="md-alert"></Icon>
        <span>{{ windowAddItem.id ? $t('编辑') : $t('新增') }}</span>
      </p>
      <Form ref="windowAddForm" :rules="windowAddValidate" :model="windowAddItem" :label-width="120">
        <FormItem label='提现卡类型' prop='setting_pay_channel_id'>
          <Select v-model='windowAddItem.setting_pay_channel_id' @on-change="windowSelectChange" style='width:200px'>
            <Option :key="key" :value="value.id"
                    v-for="(value, key) in allPayTitle"> {{ value.pay_name }}
            </Option>
          </Select>
        </FormItem>
        <FormItem label='用户名' prop='username'>
          <Input v-model='windowAddItem.username' :placeholder="$t('请输入用户名')" :disabled="windowAddItem.id"></Input>
        </FormItem>

        <FormItem :label='value.name' :prop="key" v-for="(value, key) in  windowAdd.config_user">

          <Input v-if="!value.option" :key="key" v-model="windowAddItem[key]" :placeholder="value.name"></Input>

          <Select v-else v-model="windowAddItem[key]" style='width:200px'>
            <Option key="k" :value="k" v-for="(v, k) in value.option"> {{ v }}
            </Option>
          </Select>
        </FormItem>

        <FormItem label='状态' prop='is_lock'>
          <Select v-model='windowAddItem.is_lock' style='width:200px'>
            <Option :value="'0'" :key='0'>{{ $t('正常') }}</Option>
            <Option :value="'1'" :key='1'>{{ $t('锁定') }}</Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="windowAddCancel()" class="margin-right-10">{{ $t('取消') }}</Button>
        <Button type="primary" @click="windowAddSubmit" :loading="windowAdd.loading">{{ $t('确定') }}</Button>
      </div>
    </Modal>
    <!--    -->
  </div>
</template>
<script>
import {
  getList,
  add,
  del,
  getAllPayType,
  lock
} from '@/api/userManage/userWithdrawCar'
import {
  formattingMonth,
  lastMonthDate
} from '@/libs/time'
import { getRechargeBillTypes } from '../../api/userManage/userWithdrawCar'

export default {
  name: 'interface_list',
  data () {
    return {
      timeOptions: {
        shortcuts: [{
          text: '今天',
          value () {
            let a = new Date(new Date(new Date().toLocaleDateString()).getTime())
            let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
            return [a, b]
          }
        },
          {
            text: '昨天',
            value () {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 + 24 * 60 *
                60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '一周',
            value () {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 * 7)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '本月',
            value () {
              return formattingMonth()
            }
          },
          {
            text: '上月',
            value () {
              return lastMonthDate()
            }
          },
        ]
      },
      columnsList: [{
        title: this.$t('会员帐号'),
        key: 'username',

        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('提现卡类型'),
        key: 'pay_name',

        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('是否锁定'),
        align: 'center',
        minWidth: 100,
        key: 'is_lock',
        render: (h, params) => {
            return h('div', [
              h('span', {
                style: {
                  color: params.row.is_lock?'#ed4014':'#19be6b',
                  borderRadius: '11px',
                  border: params.row.is_lock?'1px solid #ed4014':'1px solid #19be6b',
                  display: 'block',
                  height: '25px',
                  width: '70%',
                  lineHeight: '25px',
                  margin: 'auto'
                },
              }, params.row.is_lock?this.$t('锁定'):this.$t('正常')),
            ])
        }
      }, {
        title: this.$t('参数1~参数3'),
        align: 'center',
        minWidth: 250,
        render: (h, params) => {
          let vm = this
          return h('div', [h('p', {
            style: {
              textAlign: 'left',
              marginLeft: '5px'
            }
          }, this.$t('参数1(') +(params.row.p1_name?params.row.p1_name:'')+ '):' + (params.row.p1_value?params.row.p1_value:params.row.p1)), h('p', {
            style: {
              textAlign: 'left',
              marginLeft: '5px'
            }
          }, this.$t('参数2(') +(params.row.p2_name?params.row.p2_name:'')+ '):' + (params.row.p2_value?params.row.p2_value:params.row.p2)), h('p', {
            style: {
              textAlign: 'left',
              marginLeft: '5px'
            }
          }, this.$t('参数3(') +(params.row.p3_name?params.row.p3_name:'')+ '):' + (params.row.p3_value?params.row.p3_value:params.row.p3)),])
        }
      }, {
        title: this.$t('参数4~参数6'),
        align: 'center',
        minWidth: 200,
        render: (h, params) => {
          let vm = this
          return h('div', [h('p', {
            style: {
              textAlign: 'left',
              marginLeft: '5px'
            }
          }, this.$t('参数4(') +(params.row.p4_name?params.row.p4_name:'')+ '):' + (params.row.p4_value?params.row.p4_value:params.row.p4)), h('p', {
            style: {
              textAlign: 'left',
              marginLeft: '5px'
            }
          }, this.$t('参数5(') +(params.row.p5_name?params.row.p5_name:'')+ '):'+ (params.row.p5_value?params.row.p5_value:params.row.p5)), h('p', {
            style: {
              textAlign: 'left',
              marginLeft: '5px'
            }
          }, this.$t('参数6(') +(params.row.p6_name?params.row.p6_name:'')+ '):' + (params.row.p6_value?params.row.p6_value:params.row.p6)),])
        }
      }, {
        title: this.$t('添加时间'),
        key: 'add_time',

        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('操作'),
        align: 'center',
        minWidth: 120,
        render: (h, params) => {
          let vm = this
          return h('div', [h('Button', {
            props: {
              type: 'primary'
            },
            style: {
              margin: '0 5px'
            },
            on: {
              'click': () => {
                let vm = this
                vm.windowAddItem.username=params.row.username;
                vm.windowAddItem.is_lock=params.row.is_lock.toString();
                vm.windowAddItem.setting_pay_channel_id=params.row.setting_pay_channel_id;
                vm.windowAddItem.p1=params.row.p1;
                vm.windowAddItem.p2=params.row.p2;
                vm.windowAddItem.p3=params.row.p3;
                vm.windowAddItem.p4=params.row.p4;
                vm.windowAddItem.p5=params.row.p5;
                vm.windowAddItem.p6=params.row.p6;
                vm.windowAddItem.id=params.row.id;
                for (var key in vm.allPayTitle) {
                  if (vm.allPayTitle[key]['id'] == params.row.pay_id) {
                    vm.windowAdd.config_user = vm.allPayTitle[key].config_user
                  }
                }
                vm.windowAdd.show = true
              }
            }
          }, this.$t('编辑')), h('Poptip', {
            props: {
              confirm: true,
              title: !params.row.is_lock ? this.$t('确定要锁定这张卡') : this.$t('确定要解锁这张卡'),
              transfer: true
            },
            on: {
              'on-ok': () => {

                lock(params.row.id).then(response => {
                  this.$Message.success(response.data.msg)
                  this.getList()
                })
                params.loading = false

              }
            }
          }, [
            h('Button', {
              style: {
                margin: '0 5px'
              },
              props: {
                type: this.$t('info'),
                placement: 'top',
                loading: params.isDeleting
              }
            }, !params.row.is_lock ? this.$t('锁定') : this.$t('解锁'))
          ]), h('Poptip', {
            props: {
              confirm: true,
              title: this.$t('您确定要删除这张卡?'),
              transfer: true
            },
            on: {
              'on-ok': () => {

                del(params.row.id).then(response => {
                  this.tableData.splice(params.index, 1)
                  this.$Message.success(response.data.msg)
                })
                params.loading = false

              }
            }
          }, [
            h('Button', {
              style: {
                margin: '0 5px'
              },
              props: {
                type: this.$t('error'),
                placement: 'top',
                loading: params.isDeleting
              }
            }, this.$t('删除'))
          ])])
        }
      },],
      tableData: [],//用于放LIST数据绑定
      allPayTitle: null,
      tableShow: { //用于分页
        currentPage: 1,
        pageSize: 10,
        listCount: 0
      },
      searchConf: { searchTime: [], }, // 搜索字段

      buttonShow: { //按钮状态显示
        edit: true,
        del: true,
        changeStatus: true
      },
      listLoading: false, //显示加载中状态
      //弹窗--------------
      windowAdd: { //弹窗
        show: false,
        loading: false,
        index: 0,
        config_user: '',
      },
      windowAddItem: { //弹窗数据绑定
        id: 0,
      },
      windowAddValidate: {//窗口校验规则
      },                            //----------------
    }
  },
  created () {
    let vm = this
    this.searchConf.username = this.$route.params.username ? this.$route.params.username : ''
    vm.getList()
    vm.hasRule('userManage/userWithdrawCar/edit').then(res => {
      vm.buttonShow.edit = res
    })
    vm.hasRule('userManage/userWithdrawCar/del').then(res => {
      vm.buttonShow.del = res
    })
    vm.hasRule('userManage/userWithdrawCar/changeStatus').then(res => {
      vm.buttonShow.changeStatus = res
    })

    if (vm.allPayTitle == null) {
      getAllPayType().then(response => {
        vm.allPayTitle = response.data.data
      })
    }
  },
  methods: {
    preAdd () {
      let vm = this
      this.windowAdd.config_user = '' //清空上次窗口缓存
      vm.windowAdd.show = true
    },
    changePage (page) {
      this.tableShow.currentPage = page
      this.getList()
    },

    windowSelectChange (pay_id) {
      let vm = this
      for (var key in vm.allPayTitle) {
        if (vm.allPayTitle[key]['id'] == pay_id) {
          this.windowAdd.config_user = vm.allPayTitle[key].config_user
        }
      }
    },
    changeSize (size) {
      this.tableShow.pageSize = size
      this.getList()
    },
    search () {
      this.tableShow.currentPage = 1
      this.getList()
    },
    getList () {
      let vm = this
      vm.listLoading = true
      getList({
        page: vm.tableShow.currentPage,
        size: vm.tableShow.pageSize,
        search: vm.searchConf
      }).then(response => {
        vm.tableData = response.data.data.list
        vm.tableShow.listCount = response.data.data.count
        vm.listLoading = false
      })
    },

    timeChange (datetimerange) { //时间修改，自动计算尾部时间
      if (datetimerange[0] !== '' && datetimerange[1] !== '') {
        let patt = /00:00:00/
        this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        if (patt.test(datetimerange[1])) {
          datetimerange[1] = datetimerange[1].replace('00:00:00', '23:59:59')
          this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        }
      } else {
        this.searchConf.searchTime = []
      }
    },
    sortChange: function ({ column, key, order }) {
      //order值可能为asc,desc,normal
      this.searchConf.order = [key, order]
      if (order == 'normal') {
        this.searchConf.order = []
      }
      this.getList()
    },
    windowAddCancel (data) {
      if (!data) {
        this.windowAddItem.id = 0
        this.$refs['windowAddForm'].resetFields()
        this.windowAdd.show = false
        this.windowAdd.loading = false
        this.windowAdd.index = 0
      }
    }, windowAddSubmit () {
      let vm = this
      vm.$refs['windowAddForm'].validate((valid) => {
        if (valid) {
          vm.windowAdd.loading = true
          if (vm.windowAddItem.id === 0) {
            add(vm.windowAddItem).then(response => {
              vm.$Message.success(response.data.msg)
              vm.getList()
              vm.windowAddCancel()
            }).catch(() => {
              vm.windowAdd.loading = false
            })
          } else {
            add(vm.windowAddItem).then(response => {
              vm.$Message.success(response.data.msg)
              vm.getList()
              vm.windowAddCancel()
            }).catch(() => {
              vm.windowAdd.loading = false
            })
          }
        }
      })
    },
  }
}
</script>
